import { render } from "./BurgerMenu.vue?vue&type=template&id=4ac86e63&scoped=true&ts=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=ts"
export * from "./BurgerMenu.vue?vue&type=script&lang=ts"

import "./BurgerMenu.vue?vue&type=style&index=0&id=4ac86e63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac86e63"]])

export default __exports__